import Sidebar from "@/components/Sidebar";
import Header from "@/components/Header";

const DashboardLayout = ({ children }) => {
  return (
    <div className="flex min-h-screen page-container">
      {/* Sidebar */}
      <Sidebar />
      
      {/* Main Content */}
      <div className="flex-1 ml-64">
        <Header />
        <main className="p-8">
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
